export default __webpack_public_path__ + "static/adac-teaser-ab02ec97baacd2de365f7c5b0a84ccb5.jpg";